import script from "./StatementSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementSummary.vue?vue&type=script&setup=true&lang=js"

import "./StatementSummary.vue?vue&type=style&index=0&id=cf04aa7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf04aa7a"]])

export default __exports__